import React, {Component} from 'react';
import { Field, reduxForm } from "redux-form";
import { connect } from 'react-redux';
import { createProject } from './project_actions';

  class CreateProject extends Component {
    renderField = (field) => {
        const { meta: { touched, error} } = field;
        return (
          <div>
            <label>{field.label}</label>
            <input
              type="text"
              {...field.input}
              />
            <div>
              {touched ? error : ''}
            </div>
          </div>
        )
      }


    onSubmit = (values) => {
      this.props.createProject( values.buyer, values.address, values.city, values.st, values.zip, values.realtor_email )
    }


    render() {
      const { handleSubmit, pristine, reset, submitting } = this.props
      return (
          <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
            <Field name ="realtor_email" type="text" component={this.renderField} label="realtor email"/>
            <Field name="buyer" type="text" component={this.renderField} label="buyer"/>
            <Field name="address" type="text" component={this.renderField} label="address"/>
            <Field name="city" type="text" component={this.renderField} label="city"/>
            <Field name="st" type="text" component={this.renderField} label="st"/>
            <Field name="zip" type="text" component={this.renderField} label="zip"/>
            <div>
              <button type="submit" disabled={submitting}>
                Submit
              </button>
              <button type="button" disabled={pristine || submitting} onClick={reset}>
                Clear Values
              </button>
            </div>
          </form>
      )
    }
  }

  const validate = (values) => {
    const errors = {};

    if (!values.realtor_email){
      errors.realtor_email = "Enter the Realtor's email"
    }

    if (!values.buyer) {
      errors.buyer = "Enter the Buyer"
    }

    if (!values.address) {
      errors.address = "Enter the Address"
    }

    if (!values.city) {
      errors.city = "Enter the City"
    }

    if (!values.st) {
      errors.st = "Enter the State"
    }

    if (!values.zip) {
      errors.zip = "Enter the Zip"
    }

    return errors;
  }


  export default reduxForm({ validate, form: 'ProjectNewForm' })(
    connect(null, { createProject })(CreateProject)
  )



// WEBPACK FOOTER //
// ./src/components/project/project_create.js